import { IS_LOCAL } from "../../config/env";
import { clientState, disconnectClient, leaveCurrentRoom } from "../photon/client";


const tryActionsBeforeClose = () => {
  window.onbeforeunload = () => {
    if (clientState.isConnected) {
      // PHOTON
      leaveCurrentRoom();
      disconnectClient();
      return "Dude, are you sure you want to refresh? Think of the kittens!";
    }
    return undefined;
  }
};

export const browserOverrides = () => {
  !IS_LOCAL && tryActionsBeforeClose();
};
